/* eslint-disable no-prototype-builtins */
import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class User extends RESTSerializer {
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // ListUsers returns an empty object if there are no results.
    // Ember Data doesn't like that - inject an empty array to appease it.
    switch (requestType) {
      case 'query':
      case 'findAll':
        if (!payload.hasOwnProperty('users')) {
          payload.users = [];
        }
        break;
    }

    return super.normalizeResponse(...arguments);
  }
}
